module.exports = __webpack_public_path__ + "img/risk-analysis.a9ba3bfb.png";